import React, { useEffect, useState } from "react";
import Pagination from "../components/Elements/Pagination";
import { fetchEntityData } from "../utils/RequestHandler";
import LoadingSpinner from "../components/Elements/LoadingSpinner";
import EmptyState from "../components/Elements/EmptyState";
import {
  Body,
  CardContent,
  CardMeta,
  CardTitle,
  Container,
  HeaderInfo,
  MetaIcon,
  MetaItem,
  Modal,
  PaginationWrapper,
  ViewCard,
  ViewCardContent,
  ViewList,
  Wrapper,
} from "../style/view.styles";
import JoinProgramForm from "../components/Elements/JoinProgramForm";
import FilterSidebar from "../components/Elements/FilterSidebar";
import { useNavigate } from "react-router-dom";
import { FiBriefcase, FiCalendar, FiMapPin } from "react-icons/fi";
import StyledLongTextInput from "../components/Inputs/StyledLongTextInput";

const filters = [
  {
    filter: "Program Type",
    options: ["Mentorship"],
  },
  {
    filter: "Delivery Mode",
    options: ["Online", "On-site"],
  },
];

export default function Programs() {
  const [programs, setPrograms] = useState([]);
  const [filteredPrograms, setFilteredPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const recordsPerPage = 9;

  useEffect(() => {
    const checkUserLoggedIn = async () => {
      const user = localStorage.getItem("user");
      setIsLoggedIn(!!user);
      if (user) {
        setIsLoggedIn(true);
        const parsedUser = JSON.parse(user);
        setUserRole(parsedUser.role);
        setUser(parsedUser);
      } else {
        setIsLoggedIn(false);
        setUserRole(null);
      }
    };

    const fetchPrograms = async () => {
      try {
        const data = await fetchEntityData("programs");
        if (data.success) {
          const records =
            isLoggedIn && userRole === "organization"
              ? data.result.filter(
                  (record) => record.added_by === user.username
                )
              : data.result;
          setPrograms(records);
          setFilteredPrograms(records);
          if (records.length > 0) {
            setSelectedProgram(records[0]);
          }
        }
      } catch (error) {
        console.error("Failed to fetch programs:", error);
      } finally {
        setLoading(false);
      }
    };

    checkUserLoggedIn();
    fetchPrograms();
  }, [isLoggedIn, user?.username, userRole]);

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredPrograms.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const handlePageChange = (page) => setCurrentPage(page);
  const handleModalClose = () => setIsModalOpen(false);

  const handleClickProgram = (program) => {
    setSelectedProgram(program);
    navigate("/programs-detail", {
      state: { program },
    });
  };

  return (
    <>
      <Wrapper className="paleBlueGreyBg">
        <Container>
          {/* Sidebar Section */}
          <FilterSidebar filters={filters} />
          {/* Body Section */}
          <Body>
            <HeaderInfo>
              <h1 className="font30 darkGreenColor extraBold">
                Available Programs
              </h1>
            </HeaderInfo>
            {loading && <LoadingSpinner />}
            {!loading && programs?.length === 0 && (
              <EmptyState message={"Programs soon to come."} />
            )}
            {!loading && programs?.length > 0 && (
              <ViewList>
                {currentRecords.map((record, index) => (
                  <ViewCard
                    key={index}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleClickProgram(record);
                    }}
                  >
                    <ViewCardContent>
                      <CardContent>
                        <CardTitle>{record.name}</CardTitle>
                        <StyledLongTextInput
                          value={record.description}
                          maxLength={120}
                        />
                        <CardMeta>
                          <MetaItem>
                            <MetaIcon>
                              <FiCalendar />
                            </MetaIcon>
                            <span>{record.start_date}</span>
                          </MetaItem>
                          <MetaItem>
                            <MetaIcon>
                              <FiBriefcase />
                            </MetaIcon>
                            <span>{record.type}</span>
                          </MetaItem>
                          <MetaItem>
                            <MetaIcon>
                              <FiMapPin />
                            </MetaIcon>
                            <span>{record.delivery_mode}</span>
                          </MetaItem>
                        </CardMeta>
                      </CardContent>
                    </ViewCardContent>
                  </ViewCard>
                ))}
              </ViewList>
            )}
            {filteredPrograms.length > recordsPerPage && (
              <PaginationWrapper>
                <Pagination
                  totalItems={filteredPrograms.length}
                  itemsPerPage={recordsPerPage}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </PaginationWrapper>
            )}
          </Body>
        </Container>
      </Wrapper>

      {/* Application Modal */}
      {isModalOpen && (
        <Modal>
          <JoinProgramForm
            selectedProgram={selectedProgram}
            handleModalClose={handleModalClose}
          />
        </Modal>
      )}
    </>
  );
}
